module.exports = __webpack_public_path__ + "__assets__/img/test.82b9c7a5.png";